import React, { useEffect, useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, odal, ModalHeader, ModalBody, ModalFooter, Modal, Button, Alert } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";
import { datosRSerial, ObtenerDCargaPProduccion, ObtenerDInspeccionFPProduccion, ObtenerDPintadoPProduccion } from "../queries/DCUbicaciones";
import CargaPintado from "./CargaPintado";
import Pintado from "./Pintado";
import Inspeccion from "../calidad/Inspeccion";
import DetallesProduccion from "./DetallesProduccion";
import Notificar from "../navbar/Notificar";
import { GetUsuarios } from "../queries/Queries";

function GeneralProduccion({
  sProduccion,
  bColor,
  btitle,
  modulo,
  usuario,
  valorDeREtorno,
  proceso,
}) {

  const [modalGP, setModalGP] = useState(true);
  const [cargando, setCargando] = useState(false);
  const [valCP, setVarCP] = useState("");
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const [aVisible, setAVisible] = useState(false);
  const [datosProduccion, setDatosProduccion] = useState(sProduccion);
  const onDismiss = () => setAVisible(false);
  const [pUsuarios, setPUsuarios] = useState({});


  //Método useEffect
  useEffect(() => {
    fetchUsuarios();

  }, []);

  async function fetchUsuarios() {
    const apiDataU = await GetUsuarios({ usuario: { eq: usuario } });
    if (apiDataU[0]) {
      setPUsuarios(apiDataU[0]);
    } else {
      setPUsuarios({});
    }

  }

  const toggleGP = () => {
    setModalGP(!modalGP);
    valorDeREtorno({ completo: false });
  };
  function mandarEmbarcar() {
    setModalGP(!modalGP);
    valorDeREtorno({ completo: false, aEmbarcar: true, serial: sProduccion.serial });
  };
  async function handleCallback(childData) {
    setVarCP(childData);
    if (childData.completo === true) {
      const datoSerial = await datosRSerial(sProduccion.serialRecibaBTI);
      if (datoSerial.length > 0) {
        setDatosProduccion(datoSerial[0]);
      }
    } else {
      if (childData.mensaje) {
        setMensajeAlert(childData.mensaje);
        setAVisible(true);
        const datoSerial = await datosRSerial(sProduccion.serialRecibaBTI);
        setDatosProduccion(datoSerial[0]);
      }
    }

  };

  async function notificacionCreada(childData) {
    if (childData.completo === true) {
      setColor("info");
      setMensajeAlert("Notificación enviada");
      setAVisible(true);
    }
  };

  return (
    <>
      <Modal isOpen={modalGP} size="lg" toggle={toggleGP}>
        <ModalHeader toggle={toggleGP}>
          Seguimiento de material
        </ModalHeader>
        <ModalBody>
          <Row>
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                <img width="150px" src="assets/img/preloader.gif" />
              </div>
            )}
          </Row>
          <Row>
            <Table className=" mb-2 scroll ml-2 mr-2">
              <Thead class="thead-secondary">
                <Tr>
                  <Th>Cliente</Th>
                  <Th>Número de parte</Th>
                  <Th>Descripción</Th>
                  <Th>Serial </Th>
                  <Th>Serial BTI</Th>
                  <Th>Proceso</Th>
                  <Th>Cantidad Recibida</Th>
                  <Th>Cantidad Planeada</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>{datosProduccion.cliente}</Td>
                  <Td className="margintopmobil20px">
                    {datosProduccion.numerodeParte}
                  </Td>
                  {/*<Td className="margintopmobil20px">{reciba.numerodeParteSalida}</Td>*/}
                  <Td className="margintopmobil20px">
                    {datosProduccion.descripcion}
                  </Td>
                  <Td className="margintopmobil40px">
                    {datosProduccion.serial}{" "}
                  </Td>
                  <Td className="margintopmobil40px">
                    {datosProduccion.serialRecibaBTI}{" "}
                  </Td>
                  <Td className="margintopmobil20px">
                    <Label>{(datosProduccion.Ecoat === true || (!datosProduccion.Ecoat && datosProduccion.precioUnitario)) ? "Ecoat" : ""}</Label>
                    <br></br>
                    <Label className="mt-1">{datosProduccion.Pcoat === true ? "Powder coat" : ""}</Label>
                    {/*<Label className="mt-1">{datosProduccion.Platinado === true ? "Platinado" : ""}</Label>*/}
                  </Td>
                  <Td className="margintopmobil20px">
                    {datosProduccion.cantidadRecibida}
                  </Td>
                  <Td className="margintopmobil20px">
                    {datosProduccion.cantidadPlaneada}
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </Row>
          <h5 className="margintop20px">Datos de producción
            <DetallesProduccion
              sProduccion={datosProduccion}
              tipo={"todo"}
              bColor={"info floatright"}
              btitle={"Detalle de producción"}
            />
            {(datosProduccion.status ? datosProduccion.status : "") === "En reciba" && (

              <Notificar
                datosReciba={datosProduccion}
                mensaje={"Omisión de registro: No se registró la revisión de Incoming del material para el serialBTI: " + (datosProduccion.serialRecibaBTI ? datosProduccion.serialRecibaBTI : sProduccion.serialRecibaBTI)}
                btitle={"Enviar notificación de omisión de registro de Incoming"}
                bColor={"success floatright mr-1"}
                para={"Incoming"}
                modulo={modulo}
                accion={"Omisiones de registro de Incoming"}
                peticionAutTipo={""}
                tipoNotific={"Omision-Incoming"}
                usuario={usuario}
                paraSoporte={false}
                valorDeREtorno={notificacionCreada}
              />
            )}
            {((datosProduccion.piezasenAlmacen ? datosProduccion.piezasenAlmacen : 0) > 0) && (

              <Notificar
                datosReciba={datosProduccion}
                mensaje={"Omisión de registro: No se registró la carga del material para el serialBTI: " + (datosProduccion.serialRecibaBTI ? datosProduccion.serialRecibaBTI : sProduccion.serialRecibaBTI)}
                btitle={"Enviar notificación de omisión de registro de carga a Producción"}
                bColor={"success floatright mr-1"}
                para={"Producción"}
                modulo={modulo}
                accion={"Omisiones de registro de Carga"}
                peticionAutTipo={"Omitir registro de Carga"}
                tipoNotific={"Omision-Carga"}
                usuario={usuario}
                paraSoporte={false}
                valorDeREtorno={notificacionCreada}
              />
            )}
            {((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) <
              (datosProduccion.piezasenCarga ? datosProduccion.piezasenCarga : 0)) && (

                <Notificar
                  datosReciba={datosProduccion}
                  mensaje={"Omisión de registro: No se registró el pintado del material para el serialBTI: " + (datosProduccion.serialRecibaBTI ? datosProduccion.serialRecibaBTI : sProduccion.serialRecibaBTI)}
                  btitle={"Enviar notificación de omisión de registro de pintado a Producción"}
                  bColor={"success floatright mr-1"}
                  para={"Producción"}
                  modulo={modulo}
                  accion={"Omisiones de registro de Pintado"}
                  peticionAutTipo={"Omitir registro de Pintado"}
                  tipoNotific={"Omision-Pintado"}
                  usuario={usuario}
                  paraSoporte={false}
                  valorDeREtorno={notificacionCreada}
                />
              )}
            {(((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) -
              ((datosProduccion.piezasCalidad ? datosProduccion.piezasCalidad : 0) +
                (datosProduccion.piezasNoAceptadas ? datosProduccion.piezasNoAceptadas : 0))) > 0 &&
              modulo != "Calidad") && (
                <Notificar
                  datosReciba={datosProduccion}
                  mensaje={"Omisión de registro: No se registró el inspección final del material para el serialBTI: " + (datosProduccion.serialRecibaBTI ? datosProduccion.serialRecibaBTI : sProduccion.serialRecibaBTI)}
                  btitle={"Enviar notificación de omisión de registro de inspección a Calidad"}
                  bColor={"success floatright mr-1"}
                  para={"InspeccionC"}
                  modulo={modulo}
                  accion={"Omisiones de registro de Inspección final"}
                  peticionAutTipo={"Omitir registro de Inspección final"}
                  tipoNotific={"Omision-InspeccionF"}
                  usuario={usuario}
                  paraSoporte={false}
                  valorDeREtorno={notificacionCreada}
                />
              )}
          </h5>
          <Row>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">Piezas en Almacén</Label> <Label>
                {((datosProduccion.piezasenAlmacen ? datosProduccion.piezasenAlmacen : 0) > 0 &&
                  ((datosProduccion.omitirCarga ? datosProduccion.omitirCarga : "") === "Aceptada") ||
                  ((pUsuarios.Produccion ? pUsuarios.Produccion : false) === true) ||
                  ((pUsuarios.AutorizarTodo ? pUsuarios.AutorizarTodo : false) === true) ||
                  ((pUsuarios.AutorizarCalidad ? pUsuarios.AutorizarCalidad : false) === true)) && (

                    <CargaPintado
                      sProduccion={datosProduccion}
                      bColor={"warning floatright ml-1"}
                      btitle={"Cargar y Pintar material"}
                      modulo={modulo}
                      tipo={"CargaPintado"}
                      usuario={usuario}
                      valorDeREtorno={handleCallback}
                    />
                  )}
                {(datosProduccion.piezasenAlmacen ? datosProduccion.piezasenAlmacen : "")}
              </Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">Piezas en carga</Label> <Label>
                {((datosProduccion.piezasenCarga ? datosProduccion.piezasenCarga : 0) -
                  (datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0)) > 0 ?
                  ((datosProduccion.piezasenCarga ? datosProduccion.piezasenCarga : 0) -
                    (datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0)) : ""}
                {(((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) <
                  (datosProduccion.piezasenCarga ? datosProduccion.piezasenCarga : 0)) &&
                  (((datosProduccion.omitirPintado ? datosProduccion.omitirPintado : "") === "Aceptada") ||
                    ((pUsuarios.Produccion ? pUsuarios.Produccion : false) === true) ||
                    ((pUsuarios.AutorizarTodo ? pUsuarios.AutorizarTodo : false) === true) ||
                    ((pUsuarios.AutorizarCalidad ? pUsuarios.AutorizarCalidad : false) === true))) && (

                    <Pintado
                      sProduccion={datosProduccion}
                      bColor={"cbutton bcolorb ml-1"}
                      btitle={"Marcar Pintado"}
                      modulo={modulo}
                      usuario={usuario}
                      valorDeREtorno={handleCallback}
                      proceso={proceso}
                    />

                  )}
              </Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">Piezas en Pintado</Label> <Label>
                {/*datosProduccion.piezasenPintado*/}
                {((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) -
                  ((datosProduccion.piezasCalidad ? datosProduccion.piezasCalidad : 0) +
                    (datosProduccion.piezasNoAceptadas ? datosProduccion.piezasNoAceptadas : 0))) > 0 ?
                  ((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) -
                    ((datosProduccion.piezasCalidad ? datosProduccion.piezasCalidad : 0) +
                      (datosProduccion.piezasNoAceptadas ? datosProduccion.piezasNoAceptadas : 0))) : ""}
                {(((datosProduccion.piezasenPintado ? datosProduccion.piezasenPintado : 0) -
                  ((datosProduccion.piezasCalidad ? datosProduccion.piezasCalidad : 0) +
                    (datosProduccion.piezasNoAceptadas ? datosProduccion.piezasNoAceptadas : 0))) &&
                  ((datosProduccion.omitirIFinal ? datosProduccion.omitirIFinal : "") === "Aceptada" ||
                    ((pUsuarios.ProduccionCalidad ? pUsuarios.ProduccionCalidad : false) === true) ||
                    ((pUsuarios.AutorizarTodo ? pUsuarios.AutorizarTodo : false) === true) ||
                    ((pUsuarios.AutorizarCalidad ? pUsuarios.AutorizarCalidad : false) === true))) > 0 && (
                    <Inspeccion
                      sProduccion={datosProduccion}
                      bColor={"cbutton btn-primary  ml-1"}
                      btitle={"Registrar inspección"}
                      modulo={modulo}
                      usuario={usuario}
                      operacion={"individual"}
                      valorDeREtorno={handleCallback}
                    />
                  )

                }
              </Label>

            </div>
          </Row>
          <h5 className="margintop20px">Datos de inspección
            {(modulo === "Embarques" && ((datosProduccion.piezasAEmbarcar ? datosProduccion.piezasAEmbarcar : 0 > 0))) && (
              <button
                className="cbutton btn-success floatright  "
                color="success"
                size="sm"
                onClick={mandarEmbarcar}
                title="Agregar material para embarcar"
              >
                <span className="fa fa-plus"> </span>
              </button>
            )}
          </h5>
          <Row>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12  ">
              <Label className="tbold">Piezas Aceptadas</Label> <Label>{datosProduccion.piezasCalidad}</Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">Piezas no aceptadas</Label> <Label>{datosProduccion.piezasNoAceptadas}</Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">Piezas no Pintadas </Label> <Label>{datosProduccion.piezasCtnaNAEmbarcar}</Label>
            </div>

          </Row>
          <h5 className="margintop20px">Piezas embarcadas</h5>
          <Row>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12  ">
              <Label className="tbold">Aceptadas</Label> <Label>{datosProduccion.PiezasEPintadas}</Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">No aceptadas</Label> <Label>{datosProduccion.PiezasENRecuperadas}</Label>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
              <Label className="tbold">No Pintadas </Label> <Label>{datosProduccion.piezasCtnaEmbarcadas}</Label>
            </div>

          </Row>
        </ModalBody>
        <ModalFooter>
          {/*<Button color="primary" onClick={"aceptarEliminar"}>
            Aceptar
          </Button>*/}
          <Button color="danger" onClick={toggleGP}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default GeneralProduccion;
